import Service from '../Service';
import { ResponseErrorBody, RequestParamsLogin } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function(uid: string) {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLogin>(
      `/api/auth/users/${uid}/email/resend`
    ).setMethod('POST')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
